
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-offers",
      function () {
        return require("private-next-pages/our-offers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-offers"])
      });
    }
  